import axios from '../../utils/axios'

const state = {
    events: [],
    totalEvents: 0,
    langs: ["ru","en","de","pl"],
    newEventsData: [],
    routes: {
        langs: 'https://evo.skylove.su/api/events/get-supported-langs',
        newEvents: '/api/v1/eventadmin/new-events',
        updateEvent: '/api/v1/eventadmin/event/',
        deleteEvent: '/api/v1/eventadmin/event/',
        eventChanged: '/api/v1/eventadmin/events/event-changed',
    },
    activeLang: 'ru'
};

const getters = {
    events: state => state.events,
    activeLang: state => state.activeLang,
    langs: state => state.langs,
    routes: state => state.routes,
};

const mutations = {
    setLangs: (state, payload) => {
        state.langs = payload;
    },
    updateEventById(state, payload) {

        state.events = state.events.map(e => {
            if (e._id === payload.id) {
                for (let i in payload) {
                    if (!e._source.hasOwnProperty(i) || i === 'id') continue;
                    e._source[i] = payload[i];
                }
            }
            return e;
        });
    },
    setEvents: (state, payload) => {
        state.events = payload;
    },
};

const actions = {
   addEventChangeByAdmin(state, payload) {

        try {

            const params_changed = {};

            for (let i in payload) {
                if (payload[i] === undefined || payload[i] === null || !payload[i]) continue;
                params_changed[i] = payload[i];
            }

            if (JSON.stringify(params_changed) === '{}') return;

            axios.post(state.getters.routes.eventChanged, params_changed)
                .then(response => {})
                .catch(error => {});

        }
        catch(error) {

        }

    },
   async getNewEvents(state) {
        axios.get(state.getters.routes.newEvents)
            .then(response => {

                if (response.status !== 200) {
                    state.commit('setEvents', []);
                    return;
                }

                if (!(response.data && response.data.error === 0 && response.data.events && response.data.events.hits && response.data.events.hits.hits)) {
                    return;
                }

                let old_data = state.getters.events;

                let new_data = response.data.events.hits.hits.map((el) => {
                    const exists_event = old_data.length === 0 ? false : old_data.find(e =>
                      e._id === el._id);

                    if (exists_event) {
                        return exists_event;
                    }

                    el._source.origin_description = el._source.description;
                    el._source.prev_new_subtitle = el._source.new_subtitle;
                    el._source.prev_status = el._source.status;

                    return el;
                });

                state.commit('setEvents', new_data);

            })
            .catch(error => {
                state.commit('setEvents', []);
            })
    },
   async updateEventByModerator(state, payload) {

        if (!payload.event) {
            return;
        }

        if (payload.request) {

            let params = {};

            params['status'] = payload.event._source.status;
            params['description'] = payload.event._source.description;
            params['creator_locale'] = payload.event._source.creator.locale;
            params['new_subtitle'] = payload.event._source.new_subtitle;
            params['new_subtitle_admin_id'] = payload.admin_id && (payload.event._source.new_subtitle !== payload.event._source.prev_new_subtitle) ? payload.admin_id : null;
            params['admin_id'] = payload.admin_id ? payload.admin_id : null;
            params['description_admin_id'] = payload.admin_id && (payload.event._source.description !== payload.event._source.origin_description) ? payload.admin_id : null;
            params['titles'] = payload.event._source.titles;

            for (let i in params) {
                if (params[i] === undefined || params[i] === "") {
                    delete params[i];
                }
            }

            await axios.put(state.getters.routes.updateEvent + payload.event._id, params)
                .then(response => {
                    if (response.status !== 200) return;

                    state.dispatch('addEventChangeByAdmin', {
                        event_id: payload.event._id,
                        status: payload.event._source.prev_status,
                        new_status: params.status,
                        admin_id: params.admin_id,
                        subtitle: payload.event._source.prev_new_subtitle,
                        new_subtitle: params.new_subtitle,
                        new_subtitle_admin_id: params.new_subtitle_admin_id,
                        description: payload.event._source.origin_description,
                        new_description: params.description,
                        description_admin_id: params.description_admin_id,
                    });

                })
                .catch(error => {})
        }

        if (payload.onlyUpdate) return;

        state.commit(
            'setEvents',
            state.getters.events.map(el => {
                if (payload.event._id === el._id) {
                    el = payload.event;
                }
                return el;
            })
        );

    },
   async getLangs(state) {
        return axios.get(state.getters.routes.langs)
            .then(response => {
                if (response.data && response.data.length > 0) {
                    state.commit('setLangs', response.data);
                }
            })
            .catch(error => {

            })
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js